import { Boundaries } from "@planzone/core";
import { Identifiable, Project } from "@planzone/dto";
import { removeLinkFromAttr } from "./utils";

function handleAddProjectExternalLinkRequest(
  project: Identifiable<Project>,
  req: Boundaries["addProjectExternalLink"]["request"],
): Identifiable<Project> {
  return req.project.uuid === project.uuid
    ? {
        ...project,
        attributes: {
          ...req.project.attributes,
          [`link.${req.link.name}.url`]: req.link.url,
          [`link.${req.link.name}.name`]: req.link.name,
        },
      }
    : project;
}
function handleAddProjectExternalLinkSuccess(
  project: Identifiable<Project>,
  req: Boundaries["addProjectExternalLink"]["success"],
): Identifiable<Project> {
  return req.project.uuid === project.uuid
    ? {
        ...project,
        attributes: {
          ...req.project.attributes,
          [`link.${req.link.name}.url`]: req.link.url,
          [`link.${req.link.name}.name`]: req.link.name,
        },
      }
    : project;
}

function handleAddProjectExternalLinkFailure(
  project: Identifiable<Project>,
  req: Boundaries["addProjectExternalLink"]["failure"],
): Identifiable<Project> {
  return req.project.uuid === project.uuid
    ? {
        ...project,
        attributes: removeLinkFromAttr(project.attributes, req.link),
      }
    : project;
}

export {
  handleAddProjectExternalLinkRequest,
  handleAddProjectExternalLinkSuccess,
  handleAddProjectExternalLinkFailure,
};
